module.exports = __webpack_public_path__ + "static/media/img4.c78869f8.png";